import { css } from '@emotion/core';
import styled from '@emotion/styled';
import React from 'react';
import { BREAKPOINTS, COLORS } from '../../ui/variables';
import InstagramIco from '../../images/icons/instagram.png';
import FacebookIco from '../../images/icons/facebook.png';
import { Link } from 'gatsby';

const Container = styled.div`
  margin: auto;
  padding: 0 40px;
  padding: 30px 100px;
  border-top: 2px solid ${COLORS.LIGHT_GRAY};
  font-size: 16px;
  color: #888;
  display: flex;
  justify-content: space-evenly;

  @media ${BREAKPOINTS.MOBILE} {
    display: block;
    text-align: center;
  }

  @media ${BREAKPOINTS.TABLET} {
    display: block;
    text-align: center;
  }

  a {
    color: #888;
    text-decoration: none;
  }
`;

const Socials = styled.div`
  list-style: none;

  li {
    margin-bottom: 0px;
  }

  @media ${BREAKPOINTS.MOBILE} {
    text-align: center;
    position: relative;
    top: -50px;
    margin: 20px;
  }

  @media ${BREAKPOINTS.TABLET} {
    text-align: center;
    position: relative;
    top: -50px;
    margin: 20px;
  }
`;

const AdditionalLinks = styled.ul`
  list-style: none;
  margin: 0;
  display: flex;
  justify-content: flex-end;
  width: 40%;

  @media ${BREAKPOINTS.MOBILE} {
    width: 100%;
    display: block;
    text-align: center;
    margin-top: 30px;
  }

  @media ${BREAKPOINTS.TABLET} {
    width: 100%;
    display: block;
    text-align: center;
    margin-top: 30px;
  }

  li {
    margin: 0 32px 0 0;

    @media ${BREAKPOINTS.MOBILE} {
      margin: 0 0 16px 0;
    }

    @media ${BREAKPOINTS.TABLET} {
      margin: 0 0 16px 0;
    }
  }

  li:last-of-type {
    margin: 0;
  }
`;

const Footer = () => {
  return (
    <Container>
      <span
        css={css`
          width: 40%;

          @media ${BREAKPOINTS.MOBILE} {
            width: 100%;
            position: relative;
            top: 50px;
          }

          @media ${BREAKPOINTS.TABLET} {
            width: 100%;
            position: relative;
            top: 50px;
          }
        `}
      >
        © {new Date().getFullYear()} Small Door Inc.
      </span>
      <Socials>
        <li>
          <a
            href='https://www.instagram.com/smalldoorvet/'
            target='_blank'
            rel='noreferrer'
          >
            <img
              css={css`
                margin-bottom: -5px;
                width: 24px;
                height: 24px;
              `}
              src={InstagramIco}
              width='20'
              height='20'
            />
          </a>
          <a
            css={css`
              margin-left: 24px;
            `}
            href='https://www.facebook.com/smalldoorvet/'
            target='_blank'
            rel='noreferrer'
          >
            <img
              css={css`
                margin-bottom: -5px;
                width: 24px;
                height: 24px;
              `}
              src={FacebookIco}
              width='20'
              height='20'
            />
          </a>
        </li>
      </Socials>
      <AdditionalLinks>
        <li>
          <Link to='/accessibility'>Accessibility</Link>
        </li>
        <li>
          <Link to='/legal/privacy'>Privacy Policy</Link>
        </li>
        <li>
          <Link to='/legal/terms'>Terms of Service</Link>
        </li>
      </AdditionalLinks>
    </Container>
  );
};

export default Footer;
